<template>
  <generic-modal
    size="large"
    :title="$t('bundle')"
    icon="cubes"
    image="/images/icons/nvidia-round.jpeg"
    :show_ok="true"
    :scrolling="true"
    v-on:destroy="$emit('close')"
    :on_finished="on_finished"
    :footer_buttons="footer_buttons"
    ref="modal"
  >
    <div class="description">
      <div class="ui four item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="general">{{ $t("general") }}</a>
        <a class="item" data-tab="codes">{{ $t("codes") }}</a>
        <a class="item" data-tab="files">{{ $t("files") }}</a>
        <a class="item" data-tab="exchange">{{ $t("exchange page") }}</a>
        <!-- <a class="item" data-tab="graphic_cards">{{ $t("graphic cards") }}</a>
        <a class="item" data-tab="stores">{{ $t("stores") }}</a> -->
      </div>
      <div class="ui bottom attached active tab segment" data-tab="general">
        <general
          :setup="setup"
          :id="id + ''"
          ref="general"
          @update_cards="update_cards"
          @update_stores="update_stores"
        />
      </div>
      <div class="ui bottom attached tab segment" data-tab="codes">
        <codes ref="codes" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="files">
        <div class="ui form">
          <!-- <wysywyg v-model="setup.email" :show_js="false" :show_css="false" /> -->
          <div class="ui two column grid">
            <div class="column">
              <div class="field">
                <label for>{{ $t("bundle image") }}</label>
                <file-pond
                  name="bundle_image_file"
                  ref="bundle_image"
                  :label-idle="$t('click or drop files here')"
                  v-bind:allow-multiple="false"
                  v-bind:allow-revert="false"
                  v-bind:server="{
                    url: api_host,
                    timeout: enterprise_setup.upload_timeout,
                    process: {
                      url: '/nvidia_bundle/bundle/do-upload-image',
                      method: 'POST',
                      headers: {
                        'x-access-token': token_session,
                      },
                      withCredentials: false,
                    },
                  }"
                  v-on:error="filepond_error"
                  v-on:processfile="filepond_process"
                />
              </div>
              <span
                v-if="setup.bundle_image && setup.bundle_image.relative_path"
              >
                <div class="ui green label">
                  <i class="check icon"></i>
                  {{ $t("loaded") }}
                </div>
                <img
                  class="ui image"
                  :src="api_host + '/' + setup.bundle_image.relative_path"
                />
              </span>
            </div>
            <div class="column">
              <div class="field">
                <label for>{{ $t("instructive pdf") }}</label>
                <file-pond
                  name="bundle_pdf_file"
                  ref="bundle_pdf"
                  :label-idle="$t('click or drop files here')"
                  v-bind:allow-multiple="false"
                  v-bind:allow-revert="false"
                  v-bind:server="{
                    url: api_host,
                    timeout: enterprise_setup.upload_timeout,
                    process: {
                      url: '/nvidia_bundle/bundle/do-upload-pdf',
                      method: 'POST',
                      headers: {
                        'x-access-token': token_session,
                      },
                      withCredentials: false,
                    },
                  }"
                  v-on:error="filepond_error_pdf"
                  v-on:processfile="filepond_process_pdf"
                />
                <span
                  v-if="
                    setup.instructive_pdf_link &&
                    setup.instructive_pdf_link.relative_path
                  "
                >
                  <div class="ui green label">
                    <i class="check icon"></i>
                    {{ $t("loaded") }}
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="exchange">
        <exchange :setup="setup" ref="exchange" />
      </div>
      <!-- <div class="ui bottom attached tab segment" data-tab="stores">
        <graphic-cards :setup="setup" ref="stores" />
      </div> -->
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import {
  local_api,
  enterprise_setup,
  api_host,
  error_toast,
  success_toast,
} from "@/utils";
import filters from "@/filters";
// import Wysywyg from "@/components/Wysywyg/Wysywyg";
import General from "./BundleGeneral";
import Codes from "./Codes";
import Exchange from "./Exchange";
import "filepond/dist/filepond.min.css";
import vueFilePond from "vue-filepond";
const FilePond = vueFilePond();

export default {
  name: "NvidiaBundleBundleModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
    // Wysywyg,
    General,
    Codes,
    Exchange,
    FilePond,
    // GraphicCards,
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  props: {
    selected_store: Object,
  },
  data() {
    return {
      id: "",
      setup: {
        name: "",
        start_date: "",
        end_date: "",
        grace_days: 0,
        cards: "",
        stores: "",
        assets_link: "",
        email: {
          html: "",
          js: "",
          css: "",
        },
        page: {
          html: "",
          js: "",
          css: "",
        },
        bundle_image: {},
        instructive_pdf_link: {},
        legals: "",
        terms: "",
      },
      api_host: api_host,
      footer_buttons: [
        {
          icon: "trash",
          color: "red",
          text: this.$t("delete"),
          click: this.remove,
        },
        {
          icon: "log out",
          color: "orange",
          text: this.$t("close"),
          click: this.close,
        },
      ],
    };
  },
  methods: {
    on_finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        let setup = vm.setup;
        setup.graphic_cards_options = vm.$refs.general.getData();
        local_api(vm, "post", "/nvidia_bundle/bundle/do-save", {
          setup: setup,
          bi: vm.id,
        })
          .then(function (r) {
            resolve(r);
            vm.$emit("succedded", vm.setup);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    },
    setBundle(bundle) {
      let vm = this;
      vm.id = bundle.bundle_id;
      vm.setup = bundle.setup;

      if (!vm.setup.email)
        vm.setup.email = {
          html: "",
          js: "",
          css: "",
        };
      if (!vm.setup.page)
        vm.setup.page = {
          html: "",
          js: "",
          css: "",
        };

      setTimeout(() => {
        vm.$refs.general.setData(bundle);
      }, 500);

      vm.$refs.codes.init(bundle);
    },
    update_cards(value) {
      this.setup.cards = value;
    },
    update_stores(value) {
      this.setup.stores = value;
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      // let x1 = this.$refs.pond;
      // console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        // console.log("setting", r.data, "in this.bundle_image");
        if (!r.success) this.$alertify.error(r.error);
        else this.setup.bundle_image = r.data;
        // x1.removeFiles().then((r) => {
        //   console.log(r);
        // });
      }
    },
    filepond_error_pdf(a, b) {
      console.log("error", a, b);
    },
    filepond_process_pdf(event, inst) {
      // let x1 = this.$refs.pond;
      // console.log(x1, inst);
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) this.$alertify.error(r.error);
        else this.setup.instructive_pdf_link = r.data;
        // x1.removeFiles().then((r) => {
        //   console.log(r);
        // });
      }
    },
    remove() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove bundle?"),
        function () {
          local_api(vm, "post", "/nvidia_bundle/bundle/do-remove", {
            u: vm.id,
          })
            .then(() => {
              // console.log("graphic card removed");
              vm.$refs.modal.hide();
              vm.$emit("removed");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    close() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to close bundle?"),
        function () {
          local_api(vm, "post", "/nvidia_bundle/bundle/do-close", {
            u: vm.id,
          })
            .then(() => {
              success_toast(vm.$t("bundle has been closed"));
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  mounted() {
    let vm = this;
    // window.jQuery(".ui.menu .item").tab();
    // console.log("mountedxx");
    setTimeout(() => {
      if (vm.selected_store) {
        // console.log("init graphic card");
        vm.setup = vm.selected_store.setup;
        // Object.keys(vm.selected_store.setup).map((k) => {
        //   vm.setup[k] = vm.selected_store.setup[k];
        // });
        vm.id = vm.selected_store.store_id;

        if (vm.setup.start_date) {
          window
            .jQuery(vm.$refs.rangestart)
            .calendar("set date", vm.setup.start_date);
        }
      }
    }, 100);

    window.jQuery(vm.$refs.tabs).find(".item").tab();
  },
  watch: {},
  updated: function () {},
};
</script>
